import { loadStripe, Stripe, StripeElements, PaymentIntentResult } from '@stripe/stripe-js';
import { STRIPE_PUBLISHABLE_KEY } from '../constants';

export class StripeService {
	public stripe: Stripe | null;

	constructor() {
		this.loadStripe();
	}

	loadStripe = async () => {
		this.stripe = await loadStripe(STRIPE_PUBLISHABLE_KEY);
	};

	public async requestPayment(elements: StripeElements, clientSecret?: string): Promise<PaymentIntentResult> {
		if (clientSecret) {
			const { error } = await elements.submit();

			if (error) {
				return { error };
			}
		}

		if (!this.stripe) {
			throw new Error('Stripe.js not loaded');
		}

		return await this.stripe.confirmPayment({
			elements,
			clientSecret,
			redirect: 'if_required',
		});
	}
}
